<template>

  <el-button
    type="primary"
    v-if="loading"
    icon="el-icon-loading"
    disabled
  ></el-button>
  <el-button
    type="primary"
    @click="onSubmit"
    v-else
  >确认</el-button>
</template>

<script>
import bus from "../../utils/bus";
export default {
  name: "submitBtn",
  created() {
    // 接收http.js文件传来的通知
    bus.$on("btnStatus", (msg) => {
      this.loading = msg;
    });
  },
  data() {
    return {
      loading: false,
    };
  },
  props: {
    data: {},
    rules: {},
    url: "",
    JSON_Boolean: Boolean,
    special:""
  },
  methods: {
    // 提交
    onSubmit() {
      this.loading = true;

      if (this.JSON_Boolean) {
        this.$emit("toJSON");
      }

console.log(this.rules);
      // 当数据更新了，在dom中渲染后，自动执行该函数
      this.$nextTick(function () {

        console.log(this.rules);

        this.$post(this.url, this.data, this.rules).then((res) => {

          console.log(this.special);

          if(this.special == 'walletkey'){

            this.$message.success('应生成'+res.data.total_count+'条,已生成'+ res.data.insert_count+'条');

          }else{

          this.$message.success(res.msg);

          }
          // 触发父组件自定义事件刷新表格
          this.$emit("onSubmitDig");
          this.loading = false;
        });
      });
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/common/mine/submitBtn.vue